import React from 'react';

interface LogoProps {
  className?: string;
  variant?: 'default' | 'white';
  size?: 'small' | 'medium' | 'large';
}

export const Logo: React.FC<LogoProps> = ({ 
  className = "", 
  variant = 'default',
  size = 'medium'
}) => {
  const sizeClasses = {
    small: 'h-8',
    medium: 'h-10',
    large: 'h-12'
  };

  const filterClass = variant === 'white' ? 'brightness-0 invert' : '';

  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src="/images/mirani-marketing-logo.png" 
        alt="Mirani Marketing" 
        className={`${sizeClasses[size]} w-auto ${filterClass}`}
      />
    </div>
  );
};

export const LogoMobile: React.FC<LogoProps> = ({ 
  className = "", 
  variant = 'default' 
}) => {
  const filterClass = variant === 'white' ? 'brightness-0 invert' : '';

  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src="/images/mirani-marketing-logo.png" 
        alt="Mirani Marketing" 
        className={`h-8 w-auto ${filterClass}`}
      />
    </div>
  );
};